module.exports = __webpack_public_path__ + "static/img/nc129.19e101d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nc129.png
// module id = ac2Z
// module chunks = 73